import { useConsultation } from '@entities/consultations';
import type React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Layout, SellerMenu } from '@widgets/consultations';

import { useModalCopyMessage } from '@features/common';
import {
	ConnectButton,
	ConsultationAddress,
	ConsultationBuyer,
	ConsultationCost,
	ConsultationDate,
	ConsultationDuration,
	ConsultationStatus,
	ConsultationTime,
	ConsultationType,
	Debt,
	ModalPrepaid,
	Row,
	useConsultationCost,
	useConsultationLoader,
	useConsultationMessage,
	usePrepaid,
} from '@features/consultations';

import { Card, LargeHeader } from '@shared/ui';

import { ModalLarge } from 'library/components/common';

import * as st from './styles.module.scss';

export const AssignedConsultationModal: React.FC = () => {
	const { code, consultationId, clientId, tabCode } = useParams<{ [x: string]: string }>();
	const navigate = useNavigate();
	const id = Number(consultationId);
	const { consultation } = useConsultation(id);
	const { message } = useConsultationMessage(id);
	const { toggleCopyModal } = useModalCopyMessage();
	const { costTitle, showDebt } = useConsultationCost(id);
	const { isPrepaidOpen, togglePrepaid } = usePrepaid(id);

	useConsultationLoader(id);

	const onClose = () => navigate(`/clients/${code}/${clientId}/${tabCode}/assign`);

	return (
		<ModalLarge isOpen disableHeader onRequestClose={onClose}>
			<LargeHeader title="Консультация" onClose={onClose} right={<ConnectButton id={id} />} />
			<Layout
				User={<ConsultationBuyer id={id} />}
				Menu={<SellerMenu id={id} />}
				Consultation={
					<Card className={st.consultation__card}>
						<Row title="Тип">
							<ConsultationType id={id} />
						</Row>
						<Row title="Статус" hideBackground>
							<ConsultationStatus id={id} onClick={() => toggleCopyModal(message)} />
						</Row>
						<Row title="Дата">
							<ConsultationDate id={id} />
						</Row>
						<Row title="Время">
							<ConsultationTime id={id} />
						</Row>
						<Row title="Длительность">
							<ConsultationDuration id={id} />
						</Row>
						<Row title={costTitle}>
							<ConsultationCost id={id} />
						</Row>

						{consultation?.type === 'OF' && (
							<Row title="Адрес">
								<ConsultationAddress id={id} />
							</Row>
						)}

						{showDebt && (
							<Row title="Задолженность" hideBackground>
								<Debt id={id} onClick={togglePrepaid} />
							</Row>
						)}
					</Card>
				}
			/>
			<ModalPrepaid id={id} isOpen={isPrepaidOpen} toggle={togglePrepaid} />
		</ModalLarge>
	);
};
